import React from 'react'
// import { useStopwatch } from 'react-timer-hook'
// import TimerStyled from './TimerStyled'
import Timer from "./Timer.jsx"

export default function UseStopwatchDemo() {
  // const {
  //   seconds,
  //   minutes,
  //   hours,
  //   days
  // } = useStopwatch({ autoStart: true })


  return (
  // <>  <TimerStyled seconds={seconds} minutes={minutes} hours={hours} days={days} />

 // <TimerStyled seconds={seconds} minutes={minutes} hours={hours} days={days} />
       <Timer localStorage="timer2" interval={150} />
 )
}